<template>
  <div class="mess_box">
    <vab-collapse title="コメント履歴を閉じる">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="me_item flex_start"
      >
        <span class="time">{{ item.time || item.commentDatetime }}</span>
        <template v-if="item.status">
          <div class="me_inner flex_colum">
            <div class="flex_start flex_center_align">
              <img src="~@/assets/images/r9.png" alt="" />
              <span v-if="item.company" class="word">
                {{ item.company }}
              </span>
              <span v-else class="word">
                {{ item.partner }}
              </span>
            </div>
            <div class="state_box flex_colum">
              <div class="flex_start">
                <span
                  v-if="getReportText(item.reportType)"
                  class="report_format"
                >
                  {{ getReportText(item.reportType) }}
                </span>
                <span
                  v-if="
                    !isEqualCodeEnum(
                      item.status,
                      $divisions.reportStatusEnum.enum_04
                    )
                  "
                  class="state_word_blue"
                >
                  <svg-icon icon-class="check_line" />
                  <span>
                    {{ getEnumText(item.status, $divisions.reportStatusEnum) }}
                  </span>
                </span>
                <span
                  v-if="
                    isEqualCodeEnum(
                      item.status,
                      $divisions.reportStatusEnum.enum_04
                    )
                  "
                  class="state_word_red"
                >
                  <svg-icon icon-class="back_2_line" />
                  <span>
                    {{ getEnumText(item.status, $divisions.reportStatusEnum) }}
                  </span>
                </span>
              </div>
              <div v-if="item.comment" class="tichu">
                {{ item.comment }}
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="me_inner flex_colum">
            <div class="flex_start flex_center_align">
              <img src="~@/assets/images/r9.png" alt="" />
              <span v-if="item.company" class="word">
                {{ item.company }}
              </span>
              <span v-else class="word">协力会社</span>
            </div>
            <div class="state_box flex_colum">
              <div class="flex_start">
                <span
                  :class="
                    svgIcon(item.changeStatus, item.changeRequestFlg) ===
                    'back_2_line'
                      ? 'state_word_red'
                      : 'state_word_blue'
                  "
                >
                  <svg-icon
                    :icon-class="
                      svgIcon(item.changeStatus, item.changeRequestFlg)
                    "
                    class="comment_svg"
                  ></svg-icon>
                  <span>
                    {{
                      getWorkChangTimeStatus(
                        item.changeStatus,
                        item.changeRequestFlg
                      )
                    }}
                  </span>
                </span>
              </div>
              <div v-if="item.comment" class="tichu pre_wrap">
                {{ item.comment }}
              </div>
            </div>
          </div>
        </template>
      </div>
    </vab-collapse>
  </div>
</template>

<script>
  export default {
    name: 'VabMessagerc',
    props: {},
    data() {
      return {
        list: [],
      }
    },
    mounted() {},
    methods: {
      getReportText(val) {
        if (!val) return null
        let chooseOne = this.$const.reportFormatArr.filter((item) => {
          return val == item.value
        })
        return chooseOne[0].text
      },
      setList(commentList) {
        this.list = JSON.parse(commentList)
      },
      // 履歴アイコンです
      svgIcon(changeStatus, changeRequestFlg) {
        if (
          (this.isEqualCodeEnum(
            changeRequestFlg,
            this.$divisions.changeRequestFlgEnum.enum_4
          ) &&
            this.isEqualCodeEnum(
              changeStatus,
              this.$divisions.wparStatusEnum.enum_02
            )) ||
          (this.isEqualCodeEnum(
            changeStatus,
            this.$divisions.wparStatusEnum.enum_08
          ) &&
            this.isEqualCodeEnum(
              changeRequestFlg,
              this.$divisions.changeRequestFlgEnum.enum_8
            ))
        ) {
          return 'back_2_line'
        } else if (
          ([
            this.$divisions.changeRequestFlgEnum.enum_1.value,
            this.$divisions.changeRequestFlgEnum.enum_2.value,
            this.$divisions.changeRequestFlgEnum.enum_3.value,
          ].includes(changeRequestFlg) &&
            this.isEqualCodeEnum(
              changeStatus,
              this.$divisions.wparStatusEnum.enum_02
            )) ||
          ([
            this.$divisions.changeRequestFlgEnum.enum_2.value,
            this.$divisions.changeRequestFlgEnum.enum_3.value,
          ].includes(changeRequestFlg) &&
            this.isEqualCodeEnum(
              changeStatus,
              this.$divisions.wparStatusEnum.enum_07
            ))
        ) {
          return 'arrow_right_line'
        } else {
          return 'check_line'
        }
      },
      getWorkChangTimeStatus(changeStatus, changeRequestFlg) {
        if (
          this.isEqualCodeEnum(
            changeStatus,
            this.$divisions.wparStatusEnum.enum_02
          ) &&
          [
            this.$divisions.changeRequestFlgEnum.enum_1.value,
            this.$divisions.changeRequestFlgEnum.enum_2.value,
            this.$divisions.changeRequestFlgEnum.enum_3.value,
            this.$divisions.changeRequestFlgEnum.enum_4.value,
          ].includes(changeRequestFlg)
        ) {
          return this.getEnumText(
            changeRequestFlg,
            this.$divisions.changeRequestFlgEnum
          )
        } else if (
          this.isEqualCodeEnum(
            changeStatus,
            this.$divisions.wparStatusEnum.enum_08
          ) &&
          this.isEqualCodeEnum(
            changeRequestFlg,
            this.$divisions.changeRequestFlgEnum.enum_8
          )
        ) {
          return this.$divisions.changeRequestFlgEnum.enum_8.text // 依頼取消
          //対応のため変更する場合もあります。
        } else if (
          this.isEqualCodeEnum(
            changeStatus,
            this.$divisions.wparStatusEnum.enum_07
          ) &&
          this.isEqualCodeEnum(
            changeRequestFlg,
            this.$divisions.changeRequestFlgEnum.enum_2
          )
        ) {
          return this.$divisions.changeRequestFlgEnum.enum_2.text //'DLN変更依頼'
        } else if (
          this.isEqualCodeEnum(
            changeStatus,
            this.$divisions.wparStatusEnum.enum_07
          ) &&
          this.isEqualCodeEnum(
            changeRequestFlg,
            this.$divisions.changeRequestFlgEnum.enum_3
          )
        ) {
          return this.$divisions.changeRequestFlgEnum.enum_3.text //'協力会社変更依頼'
        } else {
          return this.getEnumText(changeStatus, this.$divisions.wparStatusEnum)
        }
      },
    },
  }
</script>
<style lang="scss" scoped>
  @import '@/vab/styles/reportRc.scss';
</style>
<style lang="scss" scoped>
  .report_format {
    width: 52px;
    height: 20px;
    line-height: 18px;
    background: #ffffff;
    border: 1px solid #848484;
    border-radius: 2px;
    font-style: normal;
    font-size: 12px;
    font-weight: 500;
    color: #848484;
    margin-right: 6px;
    text-align: center;
  }

  .state_word_blue {
    height: 20px;
    padding: 2px 0px;
    font-weight: 500;
    font-size: 12px;
    line-height: 100%;
    color: #0060c2;
    display: flex;
    align-items: center;
    .svg-icon {
      font-size: 16px;
    }
    span {
      font-weight: 500;
      font-size: 12px;
      line-height: 100%;
      margin-left: 2px;
    }
  }
  .state_word_red {
    height: 20px;
    padding: 2px 0px;
    font-weight: 500;
    font-size: 12px;
    line-height: 100%;
    color: #c90022;
    display: flex;
    align-items: center;
    .svg-icon {
      font-size: 16px;
    }
    span {
      font-weight: 500;
      font-size: 12px;
      line-height: 100%;
      margin-left: 2px;
    }
  }
</style>
